<template><landing v-if="presentation.renewed" /><legacy-home v-else /></template>
<script>
import Landing from './Landing.vue';
import LegacyHome from '../pages/index.vue';
import { presentation } from './presentation';
export default { components: { Landing, LegacyHome }, data: () => ({ presentation }) };
</script>
